const generate = () => `uuid-${Math.floor(Math.random() * 10000000000000000)}`;

export default {
  generate,
};
